import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql, withApollo } from '@apollo/react-hoc';
import get from 'lodash/get';
import compose from 'recompose/compose';
import throttle from 'lodash/throttle';
import { withRouter } from 'react-router-dom';
import Message from '../../components/Message';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import markAnnouncementViewedMutation from './mark-announcement-viewed-mutation';
import announcementDetails from './announcement-fragment';
import './styles.css';

export const publishedAnnouncementQuery = gql`
  query inProdNotifications {
    viewer {
      id
      publishedAnnouncement{
        id
        ...AnnouncementDetails
      }
    }
  }
  ${announcementDetails}
`;

export class InProdNotificationComponent extends React.Component {
  static propTypes = {
    client: PropTypes.shape({
      query: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired,
    }).isRequired,
    markAnnouncementViewed: PropTypes.func.isRequired,
    onReadMoreClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this._fetchAnnouncement = throttle(async () => {
      const response = await this.props.client.query({
        fetchPolicy: 'no-cache',
        query: publishedAnnouncementQuery,
      });
      this.setState({ publishedAnnouncement: get(response, 'data.viewer.publishedAnnouncement') });
    }, 30 * 1000, { leading: true, trailing: false });
  }

  state = {
    publishedAnnouncement: null,
    isButtonActive: false,
  };

  componentDidMount() {
    this._fetchAnnouncement();
    this.routerListener = this.props.history.listen(() => this._fetchAnnouncement());
    window.addEventListener('resize', this.resizeWindow);
  }

  componentWillUnmount() {
    this.routerListener();
    this._fetchAnnouncement.cancel();
    window.removeEventListener('resize', this.resizeWindow);
  }

  onReadMoreClick = () => {
    this.props.onReadMoreClick(this.state.publishedAnnouncement);
  };

  setRefReadMore = (element) => {
    this.refReadMore = element;
    if (this.refReadMore) {
      this.resizeWindow();
    }
  };

  markAnnouncementViewed = (e) => {
    e.preventDefault();
    // todo: what do we do if there's an error clearing the notification?
    this.props.markAnnouncementViewed({
      variables: {
        input: {
          announcementId: this.state.publishedAnnouncement.id,
        },
      },
    }).then(() => this.setState({ publishedAnnouncement: null }));
  };

  resizeWindow = () => {
    const { isButtonActive } = this.state;
    if (!this.refReadMore) {
      return;
    }
    const { offsetWidth, scrollWidth } = this.refReadMore;
    if (!isButtonActive && offsetWidth < scrollWidth) {
      this.setState({ isButtonActive: true });
    } else if (isButtonActive && offsetWidth >= scrollWidth) {
      this.setState({ isButtonActive: false });
    }
  };

  render() {
    const { isButtonActive, publishedAnnouncement } = this.state;
    return publishedAnnouncement && (
      <Message info size="small" icon className="toast persistent" styleName="Nav-banner">
        <Icon name="announcement" styleName="Nav-banner-icon" />
        <Message.Content styleName="content-header">
          <div styleName="content" className="hidden-mobile hidden-tablet" ref={this.setRefReadMore}>
            <b>{publishedAnnouncement.title}</b>
            <span styleName="alignNavText">{publishedAnnouncement.content}</span>
          </div>
          <div className="hidden-computer" styleName="contentMore">
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <a styleName="contentHeader" id="read-more-announcement-content" tabIndex="0" onClick={this.onReadMoreClick}>
              <b>{publishedAnnouncement.title}</b>
              <span styleName="alignNavText">{publishedAnnouncement.content}</span>
            </a>
          </div>
          <Button
            icon
            id="close-announcement-details"
            aria-label="Close Announcement"
            styleName="close"
            onClick={this.markAnnouncementViewed}
          >
            <Icon
              name="close"
              styleName="Nav-banner-icon-close"
            />
          </Button>
          {isButtonActive && (
          <Button
            id="read-more-announcement-button"
            onClick={this.onReadMoreClick}
            styleName="readmore"
            className="hidden-mobile hidden-tablet"
          >Read More
          </Button>
          )}
        </Message.Content>
      </Message>
    );
  }
}

const announcementViewed = graphql(markAnnouncementViewedMutation, {
  name: 'markAnnouncementViewed',
});

export default compose(
  withRouter,
  withApollo,
  announcementViewed,
)(InProdNotificationComponent);
